import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export interface iSectionStore {
  metricsEnabled: boolean;
  biomarkersEnabled: boolean;
  recommendationsEnabled: boolean;
  todosEnabled: boolean;
  mainEnabled: boolean;
}

export const SectionStore = create<iSectionStore>()(
  subscribeWithSelector((_) => ({
    metricsEnabled: false,
    biomarkersEnabled: false,
    recommendationsEnabled: false,
    todosEnabled: false,
    mainEnabled: false,
  }))
);
